'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _actions = require('../../../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _actions3 = require('../../../../customer/actions.js');

var _actions4 = _interopRequireDefault(_actions3);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _StepBase = require('../StepBase');

var _StepBase2 = _interopRequireDefault(_StepBase);

var _LoginForm = require('./LoginForm');

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _AnonymousUserContacts = require('./AnonymousUserContacts');

var _AnonymousUserContacts2 = _interopRequireDefault(_AnonymousUserContacts);

var _RegisteredUserContacts = require('./RegisteredUserContacts');

var _RegisteredUserContacts2 = _interopRequireDefault(_RegisteredUserContacts);

var _ContactForm = require('./ContactForm');

var _sticky = require('linksoft-albatros/src/components/sticky');

var _utils = require('../../utils');

var _utils2 = _interopRequireDefault(_utils);

var _common = require('../../../../common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App', 'Security');

function mapStateToProps(state) {
    return {
        cart: state.cart,
        mode: state.customer.contact.mode
    };
}

var mapDispatchToProps = {
    saveOptions: _actions2.default.saveOptions,
    setStep: _actions2.default.setStep,
    setMode: _actions4.default.setMode
};

var CartDetailStep3 = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_CartDetailStepBase) {
    (0, _inherits3.default)(CartDetailStep3, _CartDetailStepBase);

    function CartDetailStep3(props) {
        (0, _classCallCheck3.default)(this, CartDetailStep3);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CartDetailStep3.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep3)).call(this, props, 3));

        _this.showContactForm = function () {
            _this.props.setMode(_ContactForm.FormMode.anonymous);
            (0, _linksoftAlbatros.scrollToTop)();
        };

        _this.showLoginPane = function () {
            _this.props.setMode(_ContactForm.FormMode.login);
            (0, _linksoftAlbatros.scrollToTop)();
        };

        _this.backToEntryPoint = function () {
            _this.props.setMode(null);
        };

        _this.showRegistrationForm = function (e) {
            e.preventDefault();
            _this.props.setMode(_ContactForm.FormMode.registration);

            (0, _linksoftAlbatros.scrollTo)('.cart__step--3');
        };

        _this.renderLoginForm = function () {
            return _react2.default.createElement(
                'div',
                { style: { paddingBottom: 40 } },
                _react2.default.createElement(_LoginForm2.default, { show: _this.showRegistrationForm, goBack: _this.backToEntryPoint })
            );
        };

        _this.anonymousBack = function () {
            _this.props.mode === _ContactForm.FormMode.registration ? _this.showLoginPane() : _this.backToEntryPoint();
        };

        _this.getDeliveryTypeCulture = function (event) {
            try {
                var cart = _this.props.cart;

                var deliveryTypes = cart.deliveryTypes.map(function (dt) {
                    return dt.collection[0];
                });
                var selectedDt = deliveryTypes.find(function (dt) {
                    return dt.id === cart.deliveryTypeId;
                });
                if (selectedDt) {
                    _common2.default.setElementDatasetValueSafe('#selectedDeliveryType', 'phoneCountryCode', selectedDt.phoneCountryCode);
                    if (selectedDt.countryCode) return selectedDt.countryCode;
                    if (selectedDt.culture) return selectedDt.culture;
                }

                var dtConstant = cart.constants.find(function (c) {
                    return c.value === selectedDt.reference;
                });

                var alwaysCz = dtConstant && ['zasilkovnaCzDeliveryKey', 'zasilkovnaCzKey'].indexOf(dtConstant.key) >= 0;
                return alwaysCz || !_utils2.default.skEnvironment() ? 'cz' : 'sk';
            } catch (e) {
                console.error('Error in getDeliveryTypeCulture method.', e);
                return 'cz';
            }
        };

        return _this;
    }

    (0, _createClass3.default)(CartDetailStep3, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.setLoading(!this.props.cart.anonymous && !this.props.contact.email);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.isLoading() && this.props.contact.email) {
                this.setLoading(false);
            }
        }
    }, {
        key: 'renderAnonymousEntryPoint',
        value: function renderAnonymousEntryPoint() {
            return _react2.default.createElement(
                'div',
                { style: { paddingBottom: 40 } },
                _react2.default.createElement(
                    'div',
                    { className: 'text-center mt-5' },
                    _react2.default.createElement(
                        'a',
                        { className: 'btn btn--green step3__btn', onClick: this.showContactForm },
                        _react2.default.createElement('i', { className: 'icon--bag' }),
                        ' ',
                        Resx.App.PurchaseWithoutRegistration
                    )
                ),
                _react2.default.createElement('div', { className: 'clearfix' }),
                _react2.default.createElement('hr', null),
                _react2.default.createElement(
                    'div',
                    { className: 'text-center mt-5' },
                    _react2.default.createElement(
                        'a',
                        { className: 'btn step3__btn', onClick: this.showLoginPane },
                        _react2.default.createElement('i', { className: 'icon--bag' }),
                        ' ',
                        Resx.App.ShoppingRegisteredCustomer
                    )
                )
            );
        }
    }, {
        key: 'renderMode',
        value: function renderMode() {
            var _this2 = this;

            var isLoading = this.isLoading();
            var anonymous = this.props.cart.anonymous;

            if (anonymous && !this.props.mode) {
                return this.renderAnonymousEntryPoint();
            } else if (isLoading) return null;

            if (!anonymous) return _react2.default.createElement(_RegisteredUserContacts2.default, { onLoaded: function onLoaded() {
                    return _this2.setLoading(false);
                } });else if (this.props.mode === _ContactForm.FormMode.anonymous || this.props.mode === _ContactForm.FormMode.registration) return _react2.default.createElement(_AnonymousUserContacts2.default, { back: this.anonymousBack });else if (this.props.mode === _ContactForm.FormMode.login) return this.renderLoginForm();

            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (!this.isActive()) return null;

            return _react2.default.createElement(
                _sticky.StickyContainer,
                { className: this.stepClass() },
                _react2.default.createElement(
                    _sticky.Sticky,
                    { disableCompensation: !!(0, _linksoftAlbatros.isMaxWidth)('md') },
                    function (_ref) {
                        var style = _ref.style,
                            isSticky = _ref.isSticky,
                            wasSticky = _ref.wasSticky;
                        return _react2.default.createElement(
                            'div',
                            { style: !(0, _linksoftAlbatros.isMaxWidth)('md') ? style : {} },
                            _this3.renderMode(),
                            _react2.default.createElement('input', { type: 'hidden', id: 'selectedDeliveryType',
                                value: _this3.getDeliveryTypeCulture(event) })
                        );
                    }
                )
            );
        }
    }]);
    return CartDetailStep3;
}(_StepBase2.default), _class2.propTypes = {
    cart: _propTypes2.default.object.isRequired
}, _temp)) || _class);
exports.default = CartDetailStep3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step3/Step3.js
// module id = 1036
// module chunks = 0